<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          Users
        </CCardHeader>
        <CCardBody>
          <CDataTable
            hover
            striped
            tableFilter
            :items="items"
            :fields="fields"
            :items-per-page="30"
            clickable-rows
            :active-page="activePage"
            @row-clicked="rowClicked"
            :pagination="{ doubleArrows: false, align: 'center'}"
            @page-change="pageChange"
            class="users-table">
            <template #status_name="data">
              <td>
                <CBadge :color="getBadge(data.item.status)">
                  {{data.item.status_name}}
                </CBadge>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
export default {
  name: 'Users',
  data () {
    return {
      items: [],
      fields: [
        { key: 'name', label: 'ユーザー名', _classes: 'font-weight-bold' },
        { key: 'email', label: 'メールアドレス' },
        { key: 'tel', label: '電話番号' },
        { key: 'status_name', label: 'ステータス' },
        { key: 'closed_at', label: '利用期限' },
        { key: 'updated_at', label: '最終ログイン' },
      ],
      activePage: 1
    }
  },
  mounted: function () {
    let api = new ApiService();
    api.getUsers()
      .then((response) => {
        let adminIndex = [];
        let today = moment();
        response.forEach((item,index) => {
          if(item.is_admin == '0'){
            if(item.closed_at){
              if(!moment(item.closed_at).isAfter(today, 'day')){
                item.status = '8';
              }
            }else{
              item.closed_at = "";
            }
            item.status_name = this.getStatusName(item.status);
            this.items.push(item);
          }
        });
      })
      .catch((error) => {
        this.$swal(
          'エラー',
           "自動的にログアウトされました、再度ログインを行ってください。",
           'error',
           () => {
             this.$router.push({path: `login`})
           }
          );
      });
  },
  methods: {
    getBadge (status) {
      switch (status) {
        case '9': return 'stop' // 利用停止
        case '8': return 'outside' // 有効期限外
        case '2': return 'possible' // 利用可能
        case '1': return 'waitingadmin' // フォースタイル認証待ち
        case '0': return 'waitinguser' // 利用者認証待ち
        default: 'primary'
      }
    },
    getStatusName (status) {
      switch (status) {
        case '9': return '利用停止'
        case '8': return '有効期限外'
        case '2': return '利用可能'
        case '1': return 'フォースタイル認証待ち'
        case '0': return '利用者認証待ち'
        default: 'primary'
      }
    },
    rowClicked (item) {
      this.$router.push({path: `users/${item.id}`})
    },
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    }
  }
}
</script>
